<template>
  <div class="post">
    <div class="post_content">
      <div class="title_box">
          <img src="../assets/images/title_rencai@2x.png" class="post_title">
          <p class="post_text" >欢迎以各种方式助力我们，尤其是自荐或推荐优秀的创业人才。我们极度饥渴A/SSS象限的业务人才。</p>
      </div>
      <div class="post_instruction">
        <img src="../assets/images/card_05@2x.png" alt="">
        <img src="../assets/images/card_06@2x.png" alt="">
        <img src="../assets/images/card_07@2x.png" alt="">
        <img src="../assets/images/card_08@2x.png" alt="">
        <img src="../assets/images/card_09@2x.png" alt="">
        <img src="../assets/images/card_10@2x.png" alt="">
      </div>
      <!-- <div class="site_box">
        <img src="../assets/images/title_rc01@2x.png" class="open">
        <img src="../assets/images/title_rc02@2x.png" class="site">
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  },
  methods: {
  }
}
</script>
<style lang="less">
    .post{
    height: 100vh;
    width: 100%;
    background-color: #FFEF00;
    overflow: hidden;
    .post_content{
      max-width: 1300px;
      min-width: 980px;
      height: 100%;
      margin: 0 auto;
      position: relative;
      .title_box{
        width: 500px;
        height:60px;
        position: absolute;
        top: 150px;
        left: 120px;
        .post_title{
           width: 44%;
           vertical-align: middle;
        }
        .post_text{
          width: 48%;
          font-size: 12px;
          display: inline-block;
          margin-left: 14px;
          line-height: 18px;
          vertical-align: middle;
        }
      }
      .post_instruction{
        min-width: 850px;
        max-width: 1100px;
        height: 400px;
        margin: 0 auto;
        position: absolute;
        left: 0;
        right: 0;
        top: 280px;
        display: flex;
        flex-wrap: wrap;
        justify-content:space-around;
        img{
          width: 30%;
          height: 45%;
        }
      }
    }
  }
  // @media screen and (max-width: 1280px) {
  //     .site_box{
  //       margin: 22px 155px;
  //       text-align: center;
  //     }
  //     .open{
  //       height: 12px;
  //     }
  //     .site{
  //       height: 10px;
  //       margin-left: 22px;
  //     }
  // }
</style>



// WEBPACK FOOTER //
// src/components/post.vue